module.exports = __webpack_public_path__ + "static/startup-aa7d63be9eba1ef382d8254ee2c8ba7f.png";